import React from "react";
import { withStyles } from "@material-ui/core/styles";

const useStyles = (theme) => ({
  // your styles here
});

class Referral extends React.Component {
  componentDidMount() {
  	this.recordReferralClickAndRedirect();
  }
async recordReferralClickAndRedirect() {
    const params = new URLSearchParams(window.location.search);
    const referralId = params.get("ref") || "";

    // Gather fingerprinting data
    const userAgent = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    // Construct the data payload for your backend
    const clickData = {
      referralId,
      userAgent,
      platform,
      screenWidth,
      screenHeight,
      timestamp: new Date().toISOString(),
    };

    // Use a try/catch block for error handling on the API call
    try {
      const response = await fetch("https://us-central1-gen-exports-275913.cloudfunctions.net/notice/record_referral_click", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(clickData),
      });

      if (!response.ok) {
        console.error("Failed to send referral data to backend:", response.statusText);
      }
    } catch (error) {
      console.error("Error sending referral data:", error);
    }


    // Detect device
    let redirectUrl = "";

    if (/android/i.test(userAgent)) {
      // Android → Google Play
      redirectUrl = `https://play.google.com/store/apps/details?id=com.genexports.teaauction&referrer=${referralId}`;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // iOS → App Store
      redirectUrl = `https://apps.apple.com/in/app/tea-auction/id6740537362?ref=${referralId}`;
    } else {
      // Default → fallback web page
      redirectUrl = `https://genexports.com/`;
    }

    console.log("Redirecting to:", redirectUrl);
    window.location.href = redirectUrl;
  }

  render() {
    return (
      <div>
        <p>Redirecting...</p>
      </div>
    );
  }
}

export default withStyles(useStyles)(Referral);
